import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M12.13 6.615c.875 0 1.973-.61 2.627-1.424.592-.737 1.023-1.767 1.023-2.797 0-.14-.012-.28-.037-.394-.974.038-2.146.674-2.85 1.526-.554.648-1.06 1.665-1.06 2.708 0 .153.025.305.037.356.062.013.16.025.26.025M9.044 22c1.197 0 1.727-.826 3.22-.826 1.517 0 1.85.8 3.182.8 1.308 0 2.184-1.245 3.01-2.466.925-1.399 1.308-2.772 1.332-2.835-.086-.026-2.59-1.081-2.59-4.044 0-2.568 1.974-3.725 2.085-3.814-1.308-1.933-3.294-1.983-3.837-1.983-1.468 0-2.664.915-3.417.915-.814 0-1.887-.865-3.157-.865C6.455 6.882 4 8.942 4 12.832c0 2.417.913 4.972 2.035 6.625C6.998 20.856 7.836 22 9.045 22Z",
        }),
      ]
    )
  );
}
